import PresetsTable from "./PresetsTable";
import TemplatesTable from "./TemplatesTable";
import "./PresetsAndTemplates.scss";

const PresetsAndTemplates = function () {
  return (
    <>
      <PresetsTable />
      <TemplatesTable />
    </>
  );
};

export default PresetsAndTemplates;
